/* eslint-disable react/no-unknown-property */
import React from 'react'
import * as THREE from 'three'

import { FOCUS_OVERLAY_CONTROLS } from '../constants'

interface FocusCutoutProps {
  node: THREE.Mesh
}

function FocusCutout({ node }: FocusCutoutProps) {
  const { cutoutRenderOrder, stencilRef } = FOCUS_OVERLAY_CONTROLS

  const meshes = node.children.filter(
    (child): child is THREE.Mesh => child instanceof THREE.Mesh
  )

  return (
    <group position={node.position} rotation={node.rotation} scale={node.scale}>
      {meshes.map((mesh) => (
        <mesh
          key={`focus-cutout-mesh-${mesh.name}`}
          geometry={mesh.geometry}
          position={mesh.position}
          rotation={mesh.rotation}
          scale={mesh.scale}
          renderOrder={cutoutRenderOrder}
        >
          <meshBasicMaterial
            transparent
            colorWrite={false}
            depthWrite={false}
            polygonOffset
            polygonOffsetFactor={-1}
            polygonOffsetUnits={-1}
            stencilWrite
            stencilRef={stencilRef}
            stencilFunc={THREE.AlwaysStencilFunc}
            stencilZPass={THREE.ReplaceStencilOp}
          />
        </mesh>
      ))}
    </group>
  )
}

export default FocusCutout
